<template>
  <v-dialog v-model="showDialog" width="800px">    
    <v-card class="search-modal">
          <h2 class="mb-3">Search & Select Puppy</h2>
            <v-row>
              <v-col>
                <v-text-field
                  outlined
                  v-model="selectedLitterId"
                  label="Litter Id"
                />
              </v-col>
              <v-col>
                <v-btn v-on:click="loadPuppiesInfo" color="primary" :disabled="!hasSelectedLitterId || isSearching" :loading="isSearching">
                  <v-icon> mdi-magnify </v-icon>
                  Search
                </v-btn>
              </v-col>
            </v-row>
          <div v-if="searchResults">
              <v-data-table
                :headers="headers"
                :items="searchResults"
                class="elevation-1 full-width"
                hide-default-footer    
                :items-per-page="searchResults.length"
                item-key="id"
                show-select
                single-select
              >                
                <template v-slot:item.data-table-select="{ item }">      
                  <v-btn class="mt-2" icon v-on:click="() => onRowSelected(item)" color="primary"
                    :disabled="!(!item.dogId)">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <template v-slot:item.dogId="{ item }">
                  <a :href="`/admin/dogs/${encodeURIComponent(item.dogId)}`" target="_blank" v-if="item.dogId">{{ item.dogId}}</a>
                </template>
                <template v-slot:item.released="{ item }">
                  {{ item.released ? "Yes" : "" }}
                </template>
                <template v-slot:item.gender="{ item }">              
                  <v-autocomplete
                    disabled
                    v-model="item.gender"
                    item-text="description"
                    item-value="abbreviation"
                    :items="genders"
                    :rules="[(v) => !!v || 'Required']"
                  />
                </template>
                <template v-slot:item.mainColor="{ item }">              
                  <v-autocomplete
                    disabled
                    v-model="item.mainColor"
                    item-text="description"
                    item-value="abbreviation"
                    :items="mainColors"
                    :rules="[(v) => !!v || 'Required']"
                  />
                </template>
                <template v-slot:item.isDead="{ item }">              
                  <v-checkbox
                    disabled
                    v-model="item.isDead"
                  />
                </template>
              </v-data-table>
            </div>
            <div v-else>
              Litter not found
            </div>  
        </v-card>
      </v-dialog>
</template>
<script lang="ts">
import Vue from 'vue';
import lookupsService from "@/services/lookupsService";
import litterService from "@/services/admin/litterService";

export default Vue.extend({
  name: 'AdminLitterPuppySearchDialog',
  props: {
    litterId: { type: String },
    isEditMode: { type: Boolean },
    showPuppiesSearchDialog: { type: Boolean },
    onPuppySelected: { type: Function },
  },
  data: function() {
      return {
        searchResults: [] as any[],
        selectedLitterId: this.$props.litterId,
        headers: [
          { text: "Puppy ID", value: "id" },
          { text: "Sex", value: "gender" },
          { text: "Main Color", value: "mainColor" },
          { text: "Is Dead/Culled", value: "isDead" },
          { text: "Dog ID", value: "dogId" },
        ],
        genders: [] as any[],
        mainColors: [] as any[],
        showDialog: this.$props.showPuppiesSearchDialog,
        isSearching: false,
        searchSequence: 0,
      };
  },
  created: function () {
    lookupsService.getPuppyAttributes().then((res: any) => {
        this.genders = res.genders;
        this.mainColors = res.mainColors;
    });

    if(!!this.selectedLitterId){
      this.loadPuppiesInfo();
    }
  },
  computed: {
    hasSelectedLitterId: function (): boolean {
      return !!this.selectedLitterId?.trim();
    },
  },
  methods: { 
    onRowSelected: function(item: any){
        this.showDialog = false;
        this.onPuppySelected(item);
    },
    loadPuppiesInfo: function(supersedeCurrentSearch = false) {
        if (!this.hasSelectedLitterId || (this.isSearching && !supersedeCurrentSearch)) return;
        this.selectedLitterId = this.selectedLitterId.trim();
        const litterId = this.selectedLitterId;
        const searchSequence = ++this.searchSequence;
        this.isSearching = true;
        return litterService
          .getLitterById(litterId)
          .then((res) => {
            if (searchSequence !== this.searchSequence || litterId !== this.selectedLitterId?.trim()) return;
            if(res){
            this.searchResults = res.puppies;
          } else {
            this.searchResults = [];
          }
          })
          .catch((e) => {
            if (searchSequence !== this.searchSequence || litterId !== this.selectedLitterId?.trim()) return;
            this.searchResults = [];
          })
        .finally(() => {
          if (searchSequence !== this.searchSequence) return;
          this.isSearching = false;
        });
    },
  },
  watch: {
    selectedLitterId: function (newVal, oldVal) {
      if (newVal?.trim() !== oldVal?.trim()) this.searchResults = [];
    },
    litterId: function(newVal, oldVal){
      if(newVal != oldVal)
        if(newVal){
        this.selectedLitterId = newVal;
        this.loadPuppiesInfo(true);
        } else {
        this.selectedLitterId = newVal;
        this.searchResults = [];  
        }     
    },
    showPuppiesSearchDialog: function (newVal: boolean) {
      this.showDialog = newVal;
    },
    showDialog: function(newVal, oldVal){      
      this.$emit('update:showPuppiesSearchDialog', newVal);
    }
  },
  beforeDestroy: function () {
    this.searchSequence++;
  },
});
</script>
